var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"antialiased w-screen h-screen",attrs:{"id":"app"}},[_c('AppBar'),_c('AppTransition',[_c('router-view',{key:_vm.$route.fullPath})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }